module.exports = __webpack_public_path__ + "img/img_customers_07.16ae8457.png";